import http from "./http-common";

class ProductDocumentationDataService {

    async getTranslations() {
        const langElement = document.getElementById("language");
        const pageIdElement = document.getElementById("pageId");
        return await http.get(`/translations?language=${langElement.value}&currentpageid=${pageIdElement.value}`);
    }

    async getLanguages() {
        return await http.get('/languages');
    }

    async getCategories() {
        return await http.get('/categories');
    }

    async getProductFamilies() {
        return await http.get('/productfamilies');
    }

    async getProductData(productFamily, language, category) {
        return await http.get('/products', {
            params: {
                productFamily: productFamily,
                language: language,
                category: category,
            },
        });
    }
}

export default new ProductDocumentationDataService();